"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseSender = exports.XMLHttpSender = exports.beaconSender = void 0;
var _config;
function formatData(events) {
    if (!_config)
        throw new Error("Config not set");
    return {
        type: _config.type,
        events: events,
    };
}
// https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API#Browser_compatibility
function beaconSender(events) {
    if (!_config)
        throw new Error("Config not set");
    var sent = navigator.sendBeacon(_config.endpointURL, JSON.stringify(formatData(events)));
    if (!sent)
        throw new Error("Sending failed");
}
exports.beaconSender = beaconSender;
// This is just used for IE11
function XMLHttpSender(events, isSync) {
    if (!_config)
        throw new Error("Config not set");
    var req = new XMLHttpRequest();
    req.open("POST", _config.endpointURL, !isSync);
    req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    req.send(JSON.stringify(formatData(events)));
    // TODO: throw error?
    // req.onerror((_this, ev) => {});
}
exports.XMLHttpSender = XMLHttpSender;
/**
 * This sends the array of events to the server but returns a promise so you can
 * wait to make sure they get sent correctly.
 * @param events the array of events to send.
 */
function promiseSender(events) {
    if (!_config)
        throw new Error("Config not set");
    var req = new XMLHttpRequest();
    return new Promise(function (resolve, reject) {
        if (!_config)
            throw new Error("Config not set");
        // Setup our listener to process completed requests
        req.onreadystatechange = function () {
            // Only run if the req is complete
            if (req.readyState !== 4)
                return;
            // Process the response
            if (req.status >= 200 && req.status < 300) {
                resolve();
            }
            else {
                reject({
                    status: req.status,
                    statusText: req.statusText,
                });
            }
        };
        req.open("POST", _config.endpointURL, true);
        req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        req.send(JSON.stringify(formatData(events)));
    });
}
exports.promiseSender = promiseSender;
function getSender(config) {
    _config = config;
    // So Cypress can see the events
    return !!navigator.sendBeacon ? beaconSender : XMLHttpSender;
}
exports.default = getSender;
